import _ from 'underscore';

const ADMIN_COLUMNS = [
  {
    code: -1,
    attribute: 'select',
    display: 'Select All',
    tooltip: 'Select a set of shipments from the current view',
    localizationSlug: 'SELECT_ALL',
    tooltipLocalizationSlug: 'SELECT_ALL_COLUMN_TOOLTIP',
  },
  {
    code: 0,
    attribute: 'shipment_id',
    display: 'Shipment ID',
    tooltip: 'The Shipment ID is a unique ID provided by Cargomatic',
    localizationSlug: 'SHIPMENT_ID',
    tooltipLocalizationSlug: 'SHIPMENT_ID_COLUMN_TOOLTIP',
  },
  {
    code: 5,
    attribute: 'status',
    display: 'Status',
    tooltip: 'The current status of the shipment',
    localizationSlug: 'STATUS',
    tooltipLocalizationSlug: 'STATUS_COLUMN_TOOLTIP',
  },
  {
    code: 10,
    attribute: 'references',
    display: 'Reference Numbers',
    tooltip: 'A shipments can have many reference numbers.',
    localizationSlug: 'REFERENCES',
    tooltipLocalizationSlug: 'REFERENCES_COLUMN_TOOLTIP',
  },
  {
    code: 20,
    attribute: 'shipper_name',
    display: 'Shipper',
    tooltip: 'The shipment account owners company name',
    localizationSlug: 'SHIPPER',
    tooltipLocalizationSlug: 'SHIPPER_COLUMN_TOOLTIP',
  },
  {
    code: 30,
    attribute: 'pickup',
    display: 'Pickup',
    tooltip: 'The shipments pickup window',
    localizationSlug: 'PICKUP',
    tooltipLocalizationSlug: 'PICKUP_COLUMN_TOOLTIP',
  },
  {
    code: 40,
    attribute: 'deliver',
    display: 'Deliver',
    tooltip: 'The shipments delivery window',
    localizationSlug: 'DELIVER',
    tooltipLocalizationSlug: 'DELIVER_COLUMN_TOOLTIP',
  },
  {
    code: 50,
    attribute: 'origin',
    display: 'Starting Origin',
    tooltip: 'The shipments ultimate origin address',
    localizationSlug: 'ORIGIN',
    tooltipLocalizationSlug: 'ORIGIN_COLUMN_TOOLTIP',
  },
  {
    code: 60,
    attribute: 'destination',
    display: 'Finishing Destination',
    tooltip: 'The shipments ultimate destination address',
    localizationSlug: 'DESTINATION',
    tooltipLocalizationSlug: 'DESTINATION_COLUMN_TOOLTIP',
  },
  {
    code: 65,
    attribute: 'loads',
    display: 'Load Details',
    tooltip: 'The load details of the shipment',
    localizationSlug: 'LOAD_DETAILS',
    tooltipLocalizationSlug: 'LOAD_DETAILS_COLUMN_TOOLTIP',
  },
  {
    code: 70,
    attribute: 'carrier_name',
    display: 'Carrier',
    tooltip: 'The carrier fulfilling the shipment',
    localizationSlug: 'CARRIER',
    tooltipLocalizationSlug: 'CARRIER_COLUMN_TOOLTIP',
  },
  {
    code: 80,
    attribute: 'driver_name',
    display: 'Driver',
    tooltip: 'The driver fulfilling the shipment on behalf of a carrier',
    localizationSlug: 'DRIVER',
    tooltipLocalizationSlug: 'DRIVER_COLUMN_TOOLTIP',
  },
  {
    code: 90,
    attribute: 'tags',
    display: 'Tags',
    tooltip: 'A set of special tags used to identify a set of shipments',
    localizationSlug: 'TAGS',
    tooltipLocalizationSlug: 'TAGS_COLUMN_TOOLTIP',
  },
  {
    code: 100,
    attribute: 'shipper_cost',
    display: 'Shipper Cost',
    tooltip: 'The shipper cost for the shipment',
    localizationSlug: 'SHIPPER_COST',
    tooltipLocalizationSlug: 'SHIPPER_COST_COLUMN_TOOLTIP',
  },
  {
    code: 110,
    attribute: 'carrier_payout',
    display: 'Carrier Payout',
    tooltip: 'The carrier payout for the shipment',
    localizationSlug: 'CARRIER_PAYOUT',
    tooltipLocalizationSlug: 'CARRIER_PAYOUT_COLUMN_TOOLTIP',
  },
  {
    code: 120,
    attribute: 'actual_progress',
    display: 'Actual Progress',
    tooltip: 'The actual percentage of completion',
    localizationSlug: 'ACTUAL_PROGRESS',
    tooltipLocalizationSlug: 'ACTUAL_PROGRESS_COLUMN_TOOLTIP',
  },
  {
    code: 130,
    attribute: 'expected_progress',
    display: 'Expected Progress',
    tooltip: 'The expected percentage of completion',
    localizationSlug: 'EXPECTED_PROGRESS',
    tooltipLocalizationSlug: 'EXPECTED_PROGRESS_COLUMN_TOOLTIP',
  },
  {
    code: 140,
    attribute: 'shipment_type',
    display: 'Shipment Type',
    tooltip: 'The type of shipment',
    localizationSlug: 'SHIPMENT_TYPE',
    tooltipLocalizationSlug: 'SHIPMENT_TYPE_COLUMN_TOOLTIP',
  },
  {
    code: 150,
    attribute: 'equipments',
    display: 'Equipment',
    tooltip: 'Equipment on the shipment',
    localizationSlug: 'EQUIPMENT',
    tooltipLocalizationSlug: 'EQUIPMENT_COLUMN_TOOLTIP',
  },
];

const SHIPPER_COLUMNS = [
  {
    code: 0,
    attribute: 'shipment_id',
    display: 'Shipment ID',
    tooltip: 'Each shipment has a unique generated Shipment ID',
    localizationSlug: 'SHIPMENT_ID',
    tooltipLocalizationSlug: 'SHIPMENT_ID_COLUMN_TOOLTIP',
  },
  {
    code: 5,
    attribute: 'status',
    display: 'Status',
    tooltip: 'The current status of the shipment',
    localizationSlug: 'STATUS',
    tooltipLocalizationSlug: 'STATUS_COLUMN_TOOLTIP',
  },
  {
    code: 10,
    attribute: 'references',
    display: 'Reference Numbers',
    tooltip: 'Shipments can have many reference numbers',
    localizationSlug: 'REFERENCES',
    tooltipLocalizationSlug: 'REFERENCES_COLUMN_TOOLTIP',
  },
  {
    code: 30,
    attribute: 'pickup',
    display: 'Pickup',
    tooltip: 'The pickup appointment window for the shipment',
    localizationSlug: 'PICKUP',
    tooltipLocalizationSlug: 'PICKUP_COLUMN_TOOLTIP',
  },
  {
    code: 40,
    attribute: 'deliver',
    display: 'Deliver',
    tooltip: 'The delivery appointment window for the shipment',
    localizationSlug: 'DELIVER',
    tooltipLocalizationSlug: 'DELIVER_COLUMN_TOOLTIP',
  },
  {
    code: 50,
    attribute: 'origin',
    display: 'Origin',
    tooltip: 'The origin address for the shipment',
    localizationSlug: 'ORIGIN',
    tooltipLocalizationSlug: 'ORIGIN_COLUMN_TOOLTIP',
  },
  {
    code: 60,
    attribute: 'destination',
    display: 'Destination',
    tooltip: 'The destination address for the shipment',
    localizationSlug: 'DESTINATION',
    tooltipLocalizationSlug: 'DESTINATION_COLUMN_TOOLTIP',
  },
  {
    code: 65,
    attribute: 'loads',
    display: 'Load Details',
    tooltip: 'The load details of the shipment',
    localizationSlug: 'LOAD_DETAILS',
    tooltipLocalizationSlug: 'LOAD_DETAILS_COLUMN_TOOLTIP',
  },
  {
    code: 100,
    attribute: 'shipper_cost',
    display: 'Shipper Cost',
    tooltip: 'The cost to the shipper',
    localizationSlug: 'SHIPPER_COST',
    tooltipLocalizationSlug: 'SHIPPER_COST_COLUMN_TOOLTIP',
  },
  {
    code: 110,
    attribute: 'shipment_type',
    display: 'Shipment Type',
    tooltip: 'The type of shipment',
    localizationSlug: 'SHIPMENT_TYPE',
    tooltipLocalizationSlug: 'SHIPMENT_TYPE_COLUMN_TOOLTIP',
  },
  {
    code: 120,
    attribute: 'equipments',
    display: 'Equipment',
    tooltip: 'Equipment on the shipment',
    localizationSlug: 'EQUIPMENT',
    tooltipLocalizationSlug: 'EQUIPMENT_COLUMN_TOOLTIP',
  },
];

const CARRIER_COLUMNS = [
  {
    code: 0,
    attribute: 'shipment_id',
    display: 'Shipment ID',
    tooltip: 'Each shipment has a unique generated Shipment ID',
    localizationSlug: 'SHIPMENT_ID',
    tooltipLocalizationSlug: 'SHIPMENT_ID_COLUMN_TOOLTIP',
  },
  {
    code: 5,
    attribute: 'status',
    display: 'Status',
    tooltip: 'The current status of the shipment',
    localizationSlug: 'STATUS',
    tooltipLocalizationSlug: 'STATUS_COLUMN_TOOLTIP',
  },
  {
    code: 10,
    attribute: 'references',
    display: 'Reference Numbers',
    tooltip: 'Shipments can have many reference numbers',
    localizationSlug: 'REFERENCES',
    tooltipLocalizationSlug: 'REFERENCES_COLUMN_TOOLTIP',
  },
  {
    code: 20,
    attribute: 'shipper_name',
    display: 'Shipper',
    tooltip: 'The shipment account owners company name',
    localizationSlug: 'SHIPPER',
    tooltipLocalizationSlug: 'SHIPPER_COLUMN_TOOLTIP',
  },
  {
    code: 30,
    attribute: 'pickup',
    display: 'Pickup',
    tooltip: 'The pickup appointment window for the shipment',
    localizationSlug: 'PICKUP',
    tooltipLocalizationSlug: 'PICKUP_COLUMN_TOOLTIP',
  },
  {
    code: 40,
    attribute: 'deliver',
    display: 'Deliver',
    tooltip: 'The delivery appointment window for the shipment',
    localizationSlug: 'DELIVER',
    tooltipLocalizationSlug: 'DELIVER_COLUMN_TOOLTIP',
  },
  {
    code: 50,
    attribute: 'origin',
    display: 'Origin',
    tooltip: 'The origin address for the shipment',
    localizationSlug: 'ORIGIN',
    tooltipLocalizationSlug: 'ORIGIN_COLUMN_TOOLTIP',
  },
  {
    code: 60,
    attribute: 'destination',
    display: 'Destination',
    tooltip: 'The destination address for the shipment',
    localizationSlug: 'DESTINATION',
    tooltipLocalizationSlug: 'DESTINATION_COLUMN_TOOLTIP',
  },
  {
    code: 65,
    attribute: 'loads',
    display: 'Load Details',
    tooltip: 'The load details of the shipment',
    localizationSlug: 'LOAD_DETAILS',
    tooltipLocalizationSlug: 'LOAD_DETAILS_COLUMN_TOOLTIP',
  },
  {
    code: 80,
    attribute: 'driver_name',
    display: 'Driver',
    tooltip: 'The driver fulfilling the shipment on behalf of a carrier',
    localizationSlug: 'DRIVER',
    tooltipLocalizationSlug: 'DRIVER_COLUMN_TOOLTIP',
  },
  {
    code: 110,
    attribute: 'carrier_payout',
    display: 'Carrier Payout',
    tooltip: 'The carrier payout amount',
    localizationSlug: 'CARRIER_PAYOUT',
    tooltipLocalizationSlug: 'CARRIER_PAYOUT_COLUMN_TOOLTIP',
  },
  {
    code: 120,
    attribute: 'equipments',
    display: 'Equipment',
    tooltip: 'Equipment on the shipment',
    localizationSlug: 'EQUIPMENT',
    tooltipLocalizationSlug: 'EQUIPMENT_COLUMN_TOOLTIP',
  },
];

const getSortableColumns = (active, columns) => {
  const sortable = {};
  _.each(active, (item) => {
    sortable[item] = columns[item];
  });
  return sortable;
};

const sortColumns = (active) => {
  const items = _.pairs(active);
  const sorted = items.sort((a, b) => a[1] - b[1]);

  return sorted.map((item) => item[0]);
};

const sortColumnsForStorage = (active, columns) =>
  sortColumns(getSortableColumns(active, columns));

export default {
  sortColumnsForStorage,
  SHIPPER_COLUMNS,
  CARRIER_COLUMNS,
  ADMIN_COLUMNS,
};
